import { render } from "./HtmlEditor.vue?vue&type=template&id=8c574104&scoped=true"
import script from "./HtmlEditor.vue?vue&type=script&lang=js"
export * from "./HtmlEditor.vue?vue&type=script&lang=js"

import "./HtmlEditor.vue?vue&type=style&index=0&id=8c574104&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8c574104"]])

export default __exports__